import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { AnalyticsFilterType } from "./analytics-filter-type";
import { makeReportFilterSchema } from "./base-report-filter";

export enum CompensationMethodFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

export enum CompensationMethod {
  REFUND = "refund",
  EXCHANGE = "exchange",
  STORE_CREDIT = "store_credit",
}

export const CompensationMethodFilterSchema = makeReportFilterSchema(
  AnalyticsFilterType.COMPENSATION_METHOD,
  CompensationMethodFilterQuery,
  z.array(createEnum(CompensationMethod)),
);

export type CompensationMethodFilter = z.infer<
  typeof CompensationMethodFilterSchema
>;
